import type { ClosedReason } from '../closed-reason/ClosedReason';

export class Context {
  constructor(
    readonly id: string,
    readonly mostRecentContactAt: string,
    readonly closedReason: ClosedReason | null,
  ) {}
}
